/** @jsx jsx */
import * as React from "react";
import { newFeatureBanner } from "../styles/commons/newFeatureBanner";
import { css, jsx } from "@emotion/core";

export interface NewFeatureBannerCta {
    text: string;
    onClick(): void
}
export interface NewFeatureBannerProps {
    stepsList: string[];
    featureName: string;
    ctaList?: NewFeatureBannerCta[]
}

export const NewFeatureBanner: React.FunctionComponent<NewFeatureBannerProps> = (props: NewFeatureBannerProps) => {
    return (
        <div css={newFeatureBanner.bannerContainer}>
            <div>
                <img src="/images/doctor-image.png" alt="roster banner" css={newFeatureBanner.bannerImage} />
            </div>
            <div css={newFeatureBanner.bannerRightContainer}>
                <div>
                    <h3 css={newFeatureBanner.bannerHeader}>{props.featureName}</h3>
                </div>
                <div css={newFeatureBanner.stepsListContainer}>
                    {
                        props.stepsList.map((step: string, index: number) => {
                            return (<div css={newFeatureBanner.stepsListTextWrapper}>
                                <div css={newFeatureBanner.stepsListTextBold}>{index + 1}.  </div>
                                <div css={newFeatureBanner.stepsListText}>{step}</div>
                            </div>)
                        })
                    }
                </div>
                {props.ctaList &&
                    <div css={newFeatureBanner.newFeatureCtaContainer}>
                        {
                            props.ctaList.map((cta) => <button css={newFeatureBanner.newFeatureCta} onClick={cta.onClick}>{cta.text}</button>)
                        }
                    </div>
                }

            </div>

        </div>
    )
}